import type { SVGProps } from 'react';

export function PlaneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.7 9.9c1.159 0 2.1.941 2.1 2.1s-.941 2.1-2.1 2.1h-4.774l-5.97 6.51c-.229.248-.547.39-.885.39H7.432a.602.602 0 0 1-.57-.791L8.9 14.1H5.16l-1.98 2.475a.6.6 0 0 1-.469.225H1.97a.6.6 0 0 1-.582-.746L2.4 12 1.387 7.946A.6.6 0 0 1 1.97 7.2h.742c.184 0 .356.082.469.225L5.16 9.9h3.739L6.862 3.791A.602.602 0 0 1 7.432 3h1.64c.337 0 .655.143.884.39l5.97 6.51z" />
    </svg>
  );
}
